export enum RegistrationTypes {
    Bfutr = 'bfutr2024',
    Bfutr25 = 'bfutr2025',
    Bnxt = 'bnxt2025'
}